import { Card, Heading, Paragraph } from "@digdir/designsystemet-react";
import { useTranslation } from "react-i18next";
import Img01Priser from "@/assets/maanedsplan/01-priser.png?inline";
import Img022Innrapportering from "@/assets/maanedsplan/02-innrapportering.png?inline";
import Img03Faktura from "@/assets/maanedsplan/03-faktura.png?inline";
import Img04Betaling from "@/assets/maanedsplan/04-betaling.png?inline";
import { cn } from "@/utils";

const Frist = ({
  imgSrc,
  tittel,
  hva,
  hvem,
}: {
  imgSrc: string;
  tittel: string;
  hva: string;
  hvem: string;
}) => {
  return (
    <Card className="flex flex-col space-y-3 h-full">
      <img
        src={imgSrc}
        alt=""
        aria-hidden="true"
        className="w-20 h-20 object-contain"
      />
      <Heading level={3} data-size="sm">
        {tittel}
      </Heading>
      <Heading
        level={4}
        data-size="xs"
        className="text-pretty whitespace-pre-line"
      >
        {hva}
      </Heading>
      <Paragraph className="text-pretty whitespace-pre-line">{hvem}</Paragraph>
    </Card>
  );
};

export const MaanedsplanFrister = ({ className }: { className?: string }) => {
  const { t } = useTranslation();

  return (
    <div className={cn(className, "space-y-5")}>
      <Heading>{t("pages.maanedsplan-frister.tittel")}</Heading>
      <Paragraph>{t("pages.maanedsplan-frister.beskrivelse")}</Paragraph>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 items-start">
        <Frist
          imgSrc={Img01Priser}
          tittel={t("pages.maanedsplan-frister.01-priser.tittel")}
          hva={t("pages.maanedsplan-frister.01-priser.hva")}
          hvem={t("pages.maanedsplan-frister.01-priser.hvem")}
        />
        <Frist
          imgSrc={Img022Innrapportering}
          tittel={t("pages.maanedsplan-frister.02-innrapportering.tittel")}
          hva={t("pages.maanedsplan-frister.02-innrapportering.hva")}
          hvem={t("pages.maanedsplan-frister.02-innrapportering.hvem")}
        />
        <Frist
          imgSrc={Img03Faktura}
          tittel={t("pages.maanedsplan-frister.03-faktura.tittel")}
          hva={t("pages.maanedsplan-frister.03-faktura.hva")}
          hvem={t("pages.maanedsplan-frister.03-faktura.hvem")}
        />
        <Frist
          imgSrc={Img04Betaling}
          tittel={t("pages.maanedsplan-frister.04-betaling.tittel")}
          hva={t("pages.maanedsplan-frister.04-betaling.hva")}
          hvem={t("pages.maanedsplan-frister.04-betaling.hvem")}
        />
      </div>
    </div>
  );
};
